// extracted by mini-css-extract-plugin
module.exports = {"muted":"Footer_muted__1jcQ6","wordmark":"Footer_wordmark__xrw0r","bulletLinks":"Footer_bulletLinks__2u1ny"};